class Home {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    this.initScrollTrigger();

    initDraggableList(".ig-embeds", ".ig-embed-wrapper");
  }

  initScrollTrigger() {
    const header = document.querySelector(".header");
    const headerAnnouncementBar = document.querySelector(".announcement-bar");

    gsap.fromTo(
      [header, headerAnnouncementBar],
      {
        background: "rgba(255, 255, 255, 0)",
      },
      {
        background: "rgba(255, 255, 255, 1)",
        ease: "none",
        scrollTrigger: {
          trigger: ".hero",
          start: `bottom 75%`,
          end: "bottom 65%",
          scrub: true,
        },
      }
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new Home();
});
